import { Icon } from '@successmode-ktp/kui';
import { ReactNode } from 'react';
import styled from 'styled-components';

type Props = {
  title: string;
  content: ReactNode | ReactNode[];
  description?: string;
  isFail?: boolean;
  bottomSection?: ReactNode;
};
function CompleteRequestWrapper({
  title,
  content,
  description = '',
  isFail = false,
  bottomSection,
}: Props) {
  return (
    <CompletedSection>
      <Header>
        {isFail ? (
          <Icon.WarningFilled size={30} fillColor='#FF2D55' />
        ) : (
          <Icon.CheckFilled size={30} fillColor='#246CF6' />
        )}
        <Title>{title}</Title>
        {description && <Description>{description}</Description>}
      </Header>
      <Content>{content}</Content>
      {bottomSection && bottomSection}
    </CompletedSection>
  );
}

const CompletedSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-width: 242px;
  padding: 12px 5px;
`;

const Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
`;

const Title = styled.strong`
  color: #3a3b3e;
  font-size: 14px;
  font-weight: 600;
  line-height: 150%;
  margin-top: 8px;
`;

const Content = styled.div`
  padding: 12px;
  border-radius: 6px;
  background-color: #fff;
  width: 100%;
`;

const Description = styled.p`
  color: #3a3b3e;
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
  letter-spacing: -2%;
`;

export default CompleteRequestWrapper;
